const EMPTY_TIME_SLOT = {
  start: null,
  end: null,
};

export { EMPTY_TIME_SLOT };
